import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFloatingValue } from "../../../utils/utilityFun";

const style = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');

  .card-wrap {
    display: block;
    width: 100%;
    font-family: 'DM Sans', sans-serif;
  }

  .trading-card {
    background: radial-gradient(circle at 12% 0%, rgba(34, 197, 94, 0.18), transparent 40%), linear-gradient(150deg, #0b1020, #070a12 55%, #05070c);
    border-radius: 16px;
    padding: 16px 20px 14px;
    width: 100%;
    max-width: 320px;
    max-width: 100%;
    box-shadow: 0 14px 36px rgba(0, 0, 0, 0.62), 0 0 0 1px rgba(255, 255, 255, 0.03) inset;
    position: relative;
    overflow: hidden;
    transition: box-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
    border: 1px solid #14b8a6;
    margin: 0 auto;
  }
  .trading-card::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(120deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0) 35%);
    pointer-events: none;
  }
  .trading-card:hover {
    box-shadow: 0 18px 46px rgba(0,0,0,0.72), 0 0 24px rgba(34, 197, 94, 0.22);
    transform: translateY(-3px);
    border-color: #14b8a6;
  }

  /* Active badge */
  .card-status {
    position: absolute;
    top: 16px;
    right: 16px;
    background: linear-gradient(135deg, rgba(20, 184, 166, 0.24), rgba(34, 197, 94, 0.26));
    color: #ccfbf1;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 20px;
    letter-spacing: 0.3px;
    border: 1px solid rgba(20, 184, 166, 0.55);
  }

  /* Header row */
  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
  }
  .card-title {
    display: flex;
    align-items: baseline;
    gap: 8px;
  }
  .card-platform {
    font-size: 15px;
    font-weight: 700;
    color: #f8fafc;
    letter-spacing: 0.2px;
  }
  .card-id {
    font-family: 'DM Mono', monospace;
    font-size: 14px;
    font-weight: 500;
    color: #5eead4;
  }
  .card-settings {
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(148, 163, 184, 0.25);
    cursor: pointer;
    color: #cbd5e1;
    padding: 2px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s, background 0.2s;
    margin-right: 56px; /* offset for the badge */
  }
  .card-settings:hover { color: #f8fafc; background: rgba(34, 197, 94, 0.16); border-color: rgba(20, 184, 166, 0.7); }

  /* Meta row */
  .card-meta {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    color: #a5b4c7;
    font-weight: 400;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }
  .meta-sep { color: #64748b; }

  /* Server */
  .card-server {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    color: #a5b4c7;
    padding: 4px 0 10px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.24);
    margin-bottom: 10px;
  }
  .server-dot {
    width: 6px; height: 6px; border-radius: 50%;
    background: #14b8a6; flex-shrink: 0;
    box-shadow: 0 0 10px rgba(20, 184, 166, 0.55);
  }

  /* Balance row */
  .card-balance-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
  }
  .flag-circle {
    width: 34px; height: 34px; border-radius: 50%;
    overflow: hidden; flex-shrink: 0;
    border: 2px solid rgba(20, 184, 166, 0.45);
    display: flex; align-items: center; justify-content: center;
    font-size: 20px;
    background: linear-gradient(135deg, #0f172a, #111827);
  }
  .balance-amount {
    font-size: 26px;
    font-weight: 700;
    color: #f8fafc;
    letter-spacing: -0.5px;
    line-height: 1;
  }
  .balance-currency {
    font-size: 15px;
    font-weight: 500;
    color: #94a3b8;
    margin-left: 4px;
  }

  /* Details rows */
  .card-details { margin-bottom: 12px; }
  .detail-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 0;
  }
  .detail-label {
    font-size: 13px;
    color: #94a3b8;
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .info-icon {
    width: 15px; height: 15px; border-radius: 50%;
    background: rgba(148, 163, 184, 0.18); color: #ccfbf1;
    font-size: 10px; font-weight: 700;
    display: inline-flex; align-items: center; justify-content: center;
    cursor: help; flex-shrink: 0;
  }
  .detail-value {
    font-size: 13px;
    font-weight: 500;
    color: #f8fafc;
    font-family: 'DM Mono', monospace;
  }

  /* Buttons */
  .card-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .btn-deposit {
    padding: 9px 0;
    border: 1.5px solid rgba(20, 184, 166, 0.5);
    background: linear-gradient(145deg, rgba(30, 41, 59, 0.55), rgba(15, 23, 42, 0.62));
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #ccfbf1;
    cursor: pointer;
    transition: all 0.2s;
    letter-spacing: 0.1px;
  }
  .btn-deposit:hover {
    background: linear-gradient(145deg, rgba(22, 101, 52, 0.5), rgba(30, 41, 59, 0.7));
    border-color: rgba(94, 234, 212, 0.95);
  }
  .btn-trade {
    padding: 9px 0;
    border: none;
    background: linear-gradient(135deg, #22c55e, #16a34a 52%, #15803d);
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s;
    letter-spacing: 0.1px;
    box-shadow: 0 8px 18px rgba(34, 197, 94, 0.45);
  }
  .btn-trade:hover {
    background: linear-gradient(135deg, #4ade80, #22c55e 52%, #16a34a);
    box-shadow: 0 12px 24px rgba(34, 197, 94, 0.55);
    transform: translateY(-1px);
  }
  .btn-trade:active, .btn-deposit:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    .trading-card {
      max-width: 100%;
    }
  }
`;

/* ── Gear SVG Icon ── */
const GearIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

/* ── Main Card Component ── */
export default function TradingAccountCard({
  platform = "ONEPLUS",
  accountId = "24812914",
  leverage = "500 : 1",
  accountType = "Cent Swap free STP",
  server = "STARTRADERFinancial-Live6-MT5",
  balance = "10000.00",
  currentPayout = "0.00",
  currency = "USC",
  credits = "0.00",
  isActive = true,
  flagEmoji = "🇺🇸",
}) {
  const [tooltip, setTooltip] = useState(false);
  const navigate = useNavigate();
  return (
    <>
      <style>{style}</style>
      <div className="card-wrap">
        <div className="trading-card">

          {/* Active Badge */}
          {isActive && <span className="card-status">Active</span>}

          {/* Header */}
          <div className="card-header">
            <div className="card-title">
              <span className="card-platform">{platform}</span>
              <span className="card-id">{accountId}</span>
            </div>
            <button className="card-settings" title="Account Settings">
              <GearIcon />
            </button>
          </div>

          {/* Meta */}
          {/* <div className="card-meta">
                        <span>{leverage}</span>
                        <span className="meta-sep">|</span>
                        <span>{accountType}</span>
                    </div> */}

          {/* Server */}
          <div className="card-server">
            <span className="server-dot" />
            <span>{server}</span>
          </div>

          {/* Balance */}
          <div className="card-balance-row">
            <div className="flag-circle">
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAC6UExURUdwTAYGY////+/v///6+NsvI98/N/z8/P///0JDhgAAYNkuHdsqHv///48fPwcHZwAAX+/Cv/36+v37+e+vrOfY3tguIPjY19suIFZWlgECYQAAYed9dZKSudsvIf///wABYvS9ufGspwMEZAwNafK5tJycvyAhde+hnPbLyO2YkfbSz+h4cDg4gykpetDQ4WtroxkZcLQnLIKCsFdYl5GRuvjZ17KyzsDA1uLi60tMj6OjxcF5hcintLRr38IAAAAedFJOUwDqIBBcgiD1gP6EXurZECBd6LCQ0IzHwJ/Pz7eAsJQhGOkAAAI3SURBVEjHlVaLcpswEBQ2BGPw+5FXay6RWvUFhgAFO/b//1alA5MAgsLOeG4y2ZXuVmvJhNQxX06fNQ3gzdkb9h35D8a7RwoAfuLD20Fi36mZT7VjIPhgnW4CgYdWyVQDypj4AGMUrn9LTJT0xVOQcbE6S96Z3OXofmA2avKXGsSJZNIgonWBa+qNdhguCyEFSQ9rAted1PnviSTyLJDlfPTg8qcKo9IPQID20OQsi5eEtHTpBvvTvBbIRqiXd+VjaQicD3sfTUuuHp3QpTRjSsFhXw7AzyE2YqE9loU7XH83sCsakjTqeVjiUBYWsLpLaO4YBTvZActSdOkUydVj01MJcm8XnIKQ+GJUEQufy2hwrtwh30JYaqUetpPi0FF+4JdfCnwRgicxLTIhyEMURWpbC6MWNAQZBxlTmkdDFqBKwWFOllEmPRXRYNVoqAU2mcYYTlpEI7pFA64/VdiRZxwXM8ry4nvNeJdYEw1tL6KBzaXHDsGMyP9xH+3xfZoXaBeYBHiMtltFNPgtGpcfShCanIpoQDUaapcOROO4pkgDuuTz/A/WLgA1Wg7OIV+/t+BViS3ZuIOwIfowgU7GwwTiCrx/GYCt+D4YhwGQd9PcGSDAq2nAFg/5M7LqPUJx9036WlTe4LN+/Fl5t47MPnzz0zOkv/ZA5RHq4ZRRfYKMgXxC7M7zc+zmM3q3/daKrfptbzsPc9L2U2C0VtLHHb82RnrtENed9EKzuV+Jvler9UZvsv8Bwdjr+gVO790AAAAASUVORK5CYII=" />
            </div>
            <div>
              <span className="balance-amount">{balance}</span>
              <span className="balance-currency">{currency}</span>
            </div>
          </div>

          {/* Details */}
          <div className="card-details">
            <div className="detail-row">
              <span className="detail-label">
                Profit
                <span
                  className="info-icon"
                  onMouseEnter={() => setTooltip(true)}
                  onMouseLeave={() => setTooltip(false)}
                  title="Bonus credits applied to your account"
                >i</span>
                :
              </span>
              <span className="detail-value">{credits}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Balance:</span>
              <span className="detail-value">{getFloatingValue(currentPayout)}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Withdrawal:</span>
              <span className="detail-value">{getFloatingValue(accountType)}</span>
            </div>
          </div>

          {/* Actions */}
          <div className="card-actions">
            <button className="btn-deposit"
              onClick={() => navigate("/topup_data")}
            >Deposit</button>
            <button
              onClick={() => navigate("/with")}
              className="btn-trade">Withdrawal</button>
          </div>

        </div>
      </div>
    </>
  );
}